export const NUMBER_REGEX = /^[0-9]*$/;
export const ALPAHBET_REGEX = /^[a-zA-Z ]*$/;

// Name regex pattern
export const nameRegex: RegExp = /^[a-zA-Z ]*$/;

// Email regex pattern
export const emailRegex: RegExp =
  /^(?!.*\s)\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

// Phone number regex pattern
export const INDIAN_PHONE_NUMBER_REGEX: RegExp = /^\+?[1-9]\d{9,10}$/;
export const NON_INDIAN_PHONE_NUMBER_REGEX: RegExp = /^\+?[1-9]\d{6,13}$/;

//LinkedIn regex pattern
export const LINKEDIN_REGEX: RegExp =
  /^((http|https):\/\/)?(www\.)?([A-Za-z]+\.)?linkedin\.com\/(pub|in|profile)\/[A-Za-z0-9-_]+\/?$/;
export const LINK_REGEX: RegExp =
  /^(http|https?:\/\/|www\.)[^\s/$.?#].[^\s]*$/i;
